<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item
        label="设备ID,关联{zb_equipment.id}"
        prop="equipmentId"
      >
        <a-input
          v-model:value="form.equipmentId"
          placeholder="请输入设备ID,关联{zb_equipment.id}"
        />
      </a-form-model-item>
      <a-form-model-item label="操作人ID,关联{sys_user.id}" prop="operationId">
        <a-input
          v-model:value="form.operationId"
          placeholder="请输入操作人ID,关联{sys_user.id}"
        />
      </a-form-model-item>
      <a-form-model-item label="时间" prop="operationTime">
        <a-date-picker
          style="width: 100%"
          v-model:value="form.operationTime"
          format="YYYY-MM-DD HH:mm:ss"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item
        label="事由(采购、入库、调拨项目、项目退库、项目暂停、报废、维修、保养、换耗材)"
        prop="operationReason"
      >
        <a-input
          v-model:value="form.operationReason"
          placeholder="请输入事由(采购、入库、调拨项目、项目退库、项目暂停、报废、维修、保养、换耗材)"
        />
      </a-form-model-item>
      <a-form-model-item label="操作人" prop="operationName">
        <a-input
          v-model:value="form.operationName"
          placeholder="请输入操作人"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="operationRemark">
        <a-input
          v-model:value="form.operationRemark"
          placeholder="请输入备注"
        />
      </a-form-model-item>
      <a-form-model-item label="是否显示 1显示 0-不显示" prop="status">
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model:value="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入内容"
          type="textarea"
          allow-clear
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getEquipmentLog,
  addEquipmentLog,
  updateEquipmentLog,
} from '@/api/system/equipmentLog'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        equipmentId: null,

        operationId: null,

        operationTime: null,

        operationReason: null,

        operationName: null,

        operationRemark: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        equipmentId: null,
        operationId: null,
        operationTime: null,
        operationReason: null,
        operationName: null,
        operationRemark: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEquipmentLog({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEquipmentLog(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addEquipmentLog(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>
